import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { populateViewerInsightsViewers } from 'actions/viewerInsights';
import { getGraphQLClientInsights } from 'utilities/graphql';

import { selectViewers } from 'selectors/viewerInsights';

import GetInsightsForVideo from './GetInsightsForVideo.gql';

export default (videoId, immediateExecution = true) => {
  const gqlClient = useMemo(() => getGraphQLClientInsights(), []);
  const dispatch = useDispatch();
  const users = useSelector(selectViewers);

  useEffect(() => {
    if (users.length || !immediateExecution) {
      return;
    }

    gqlClient
      .query({
        variables: { videoId },
        query: GetInsightsForVideo,
        fetchPolicy: 'no-cache',
      })
      .then(({ data }) => {
        dispatch(
          populateViewerInsightsViewers(
            data.engagementInsightsSummaryForVideo.viewers
          )
        );
      })
      .catch(error => {
        console.error(error);
      });
  }, [dispatch, gqlClient, users.length, videoId, immediateExecution]);
};
